import { EPGProgram } from '../types';

export enum CellType {
    // FLOATING
    Loading = 0,
    NoData = 1,
    // NORMAL
    MissingData = 2,
    Program = 3,
}

export type CellItem<T = unknown> = {
    id: string;
    rowIndex: number;
    type: CellType;
    startTime?: number;
    endTime?: number;
    program?: EPGProgram<T>;
};

export type Point = {
    x: number;
    y: number;
};

export type Size = {
    height: number;
    width: number;
};

export type Rect = Point & Size;

export type Layout = Rect & {
    type: number;
};
